import React, { useContext, useEffect } from 'react';
import * as S from '../styled';
import Form from '../../..';
import { ExportContext } from '../../../../../provider/ExportProvider';
import { formatBRL, formatCents } from '../../../../../store/masks';
import { setFilterColumn } from '../../../../../store/utils';

export default function TabFormInvoiceTaxCreate() {
  const { getInvoice, setInvoice, filterSelectTaxes } =
    useContext(ExportContext)!.controllers.invoice;

  const { searchSelectFilter, setSearchSelectFilter } =
    useContext(ExportContext)!.controllers.tax;

  const getForm = <T extends FlattenKeys<InvoiceForm>>(field: T) =>
    getInvoice(`forms.invoices.create.${field}`);

  const setForm = <
    T extends FlattenKeys<InvoiceForm>,
    V extends DeepType<InvoiceState, `forms.invoices.create.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.invoices.create.${field}`, value);

  const invoiceTaxes = getForm('invoiceTaxes');

  const options = getInvoice('filters.selectTaxes.data.data').map((tax) => ({
    id: tax.id,
    name: tax.name,
    data: tax,
  }));

  const selectedItems = invoiceTaxes.map(({ tax }) => ({
    id: tax.id,
    name: tax.name,
    data: tax,
  }));

  const setInvoiceTaxForm = (index: number) => (e) => {
    setInvoice(
      `forms.invoices.create.invoiceTaxes.${index}.value`,
      +e.target.value ?? 0,
    );
  };

  useEffect(() => {
    let searchFilter = setFilterColumn(
      'name',
      '',
      searchSelectFilter,
      'LIKE',
      'AND',
    );
    const newInvoiceTaxes = invoiceTaxes.map(({ tax }) => tax);
    searchFilter = setFilterColumn(
      'id',
      newInvoiceTaxes.length > 0 ? newInvoiceTaxes.map(({ id }) => id) : '',
      searchFilter,
      'NOTIN',
      'AND',
    );
    setSearchSelectFilter(searchFilter);
    filterSelectTaxes();
  }, []);

  return (
    <S.Body>
      <div
        style={{
          margin: '20px',
        }}
      >
        <Form.Input.Dropdown.Multiple
          items={options}
          selectedItems={selectedItems}
          onSelected={(items) => {
            setForm(
              'invoiceTaxes',
              items.map(
                ({ data: tax }) =>
                  invoiceTaxes.find(({ tax: { id } }) => id === tax.id) ?? {
                    value: tax.value,
                    tax: tax,
                  },
              ),
            );
          }}
          onDebouncedChange={(e) => {
            let searchFilter = setFilterColumn(
              'name',
              e.target.value,
              searchSelectFilter,
              'LIKE',
              'AND',
            );
            const newInvoiceTaxes = invoiceTaxes.map(({ tax }) => tax);
            searchFilter = setFilterColumn(
              'id',
              newInvoiceTaxes.length > 0
                ? newInvoiceTaxes.map(({ id }) => id)
                : '',
              searchFilter,
              'NOTIN',
              'AND',
            );
            setSearchSelectFilter(searchFilter);
            filterSelectTaxes();
          }}
          placeholder="Selecione as taxas"
        />
      </div>
      <S.Grid>
        {invoiceTaxes.map(({ value, tax: { name } }, index) => (
          <Form.Input
            key={index}
            value={value}
            onChange={setInvoiceTaxForm(index)}
            placeholder="valor"
            label={name}
            mask={formatBRL}
            unmask={formatCents}
          />
        ))}
      </S.Grid>
    </S.Body>
  );
}
